import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { REQUIRED_TEXT_ERROR } from '@components/dynamic-input-fields/constants';
import { ErrorMessage } from '@components/error/error-message';
import { SelectItemOption } from '@components/select-item-option';

import { MultiOfferSelectorOptions } from '../invite-guest/select-type-types.type';

export const ControlledMultiOfferSelector = ({
  formName,
  type,
  typeOptions,
}: {
  formName: string;
  type: string;
  typeOptions: MultiOfferSelectorOptions[];
}) => {
  const { t } = useTranslation();
  const { register } = useFormContext();

  return (
    <section className='mb-2'>
      <fieldset
        className='flex items-stretch gap-4'
        {...register(formName, {
          required: type !== '' || t(REQUIRED_TEXT_ERROR),
        })}>
        {typeOptions.map((option) => (
          <SelectItemOption {...option} key={option.id} />
        ))}
      </fieldset>
      <ErrorMessage name={formName} />
    </section>
  );
};
